module.exports = __webpack_public_path__ + "img/offer-letter.48634a89.svg";